import { dm_doi_tuong_tuyen_sinh } from "../models/response/category/dm_doi_tuong_tuyen_sinh";
import { apiClient } from "./apiClient";

export const DOI_TUONG_TUYEN_SINH_API_END_POINT = "doi-tuong-tuyen-sinh";

export const doiTuongTuyenSinhApi = {
    select_by_coso: (dm_coso_id: number) => apiClient.get(`${DOI_TUONG_TUYEN_SINH_API_END_POINT}?dm_coso_id=${dm_coso_id}`),
    detail: (id: number) => apiClient.get(`${DOI_TUONG_TUYEN_SINH_API_END_POINT}/${id}`),
    insert: (payload: dm_doi_tuong_tuyen_sinh) => apiClient.post(`${DOI_TUONG_TUYEN_SINH_API_END_POINT}`, payload),
    update: (payload: dm_doi_tuong_tuyen_sinh) => apiClient.put(`${DOI_TUONG_TUYEN_SINH_API_END_POINT}`, payload),
    delete: (id: number) => apiClient.delete(`${DOI_TUONG_TUYEN_SINH_API_END_POINT}/${id}`)
}
